// PDF text is only a fallback; retain paragraphs, not the original page width.
const spaced = (text: string): string => [...text].join("\\s*");
const notice = new RegExp(
  `(?:${spaced("请务必在总结开头增加这段话：")})?${spaced("本文由第三方")}\\s*AI\\s*${spaced("基于财新文章")}[\\s\\S]{0,1400}?${spaced("推荐点击链接阅读原文细致比对和校验。")}`,
  "gu",
);
const sectionHeading = /^(?!文[｜|]|图[｜|]|记者[｜|]|摄影[｜|])[^｜|\n]{2,16}[｜|].{2,90}$/u;
const markdownBlock = /^(?:#{1,6}\s|[-*+]\s|\d+[.)]\s|>\s|!\[|```|~~~|\|)/u;

function joinLines(lines: string[]): string {
  return lines.reduce((text, line) => {
    if (!text) return line;
    if (/[A-Za-z]-$/u.test(text) && /^[a-z]/u.test(line)) return text.slice(0, -1) + line;
    const boundary = text.slice(-1) + line.slice(0, 1);
    return /[\u3400-\u9fff，。；：！？、（）“”《》]/u.test(boundary)
      ? text + line
      : `${text} ${line}`;
  }, "");
}

export function cleanLegacyReading(raw: string): string {
  const cleaned = raw.replace(/\r\n?/gu, "\n")
    .replace(notice, "\n\n")
    .replace(/\[《财新周刊》印刷版，[\s\S]{0,300}?\]/gu, "")
    .replace(/^(?:版面编辑|图片编辑|新媒体编辑|视觉编辑)：.*$/gmu, "");
  const lines = cleaned.split("\n");
  const output: string[] = [];
  let paragraph: string[] = [];
  function flush(): void {
    if (paragraph.length) output.push(joinLines(paragraph));
    paragraph = [];
  }
  for (let index = 0; index < lines.length; index += 1) {
    const original = lines[index]!;
    const line = original.trim();
    if (!line) { flush(); continue; }
    if (sectionHeading.test(line)) {
      flush();
      let heading = line;
      const next = lines[index + 1]?.trim() ?? "";
      // A short final fragment such as “展” belongs to a PDF-wrapped title.
      if (next && next.length <= 12 && !/[。！？：，；｜|]/u.test(next)
        && !markdownBlock.test(next) && !/^\s/u.test(lines[index + 1]!)) {
        heading = joinLines([heading, next]);
        index += 1;
      }
      const formatted = `## ${heading}`;
      if (output.at(-1) !== formatted) output.push(formatted);
    } else if (markdownBlock.test(line)) {
      flush();
      if (!line.startsWith("#") || output.at(-1) !== line) output.push(line);
    } else {
      if (/^(?: {2,}|\t|　)/u.test(original)) flush();
      paragraph.push(line);
    }
  }
  flush();
  return output.join("\n\n");
}
